// This schema is used to faciliate section prefilling for the 9089

export const sectionTitles = [
  {
    name: "Preliminary Questions",
    prefix: "Preliminary",
  },
  {
    name: "Employer Information",
    prefix: "A",
  },
  {
    name: "Employer Point-of-Contact Information",
    prefix: "B",
  },
  {
    name: "Attorney or Agent Information",
    prefix: "C",
  },
  {
    name: "Job Opportunity and Wage Information",
    prefix: "E",
  },
  {
    name: "Worksite Information",
    prefix: "F.a",
  },
  {
    name: "Additional Worksites",
    prefix: "F.b",
  },
  {
    name: "Other Definable Geographic Area(s)",
    prefix: "F.c",
  },
  {
    name: "Additional Job Opportunity Information and Other Requirements",
    prefix: "G",
  },
  {
    name: "Professional/Non-Professional Recruitment Information",
    prefix: "H.c",
  },
  {
    name: "Additional Recruitment Requirements for Professional Occupations",
    prefix: "H.d",
  },
  {
    name: "Notice of Posting",
    prefix: "H.e",
  },
  {
    name: "Preparer",
    prefix: "J",
  },
  {
    name: "Appendix B - Additional Worksite Information",
    prefix: "APX B",
  },
  {
    name: "Appendix C - Supplemental Information",
    prefix: "APX C",
  },
  {
    name: "Appendix D - Special Recruitment for College and University Teachers",
    prefix: "APX D",
  },
];

export default {
  Preliminary: [
    "occupationType",
    "supervisedRecruitment",
    "supervisedRecruitmentAttached",
    "jobOppPWDNumber",
    "playerContractAttached",
    "offSeasonAttached",
    "unionLetterAttached",
    "professionalAssociationAttached",
    "teamRevenueAttached",
    "playerStatisticsAttached",
  ],
  A: [
    "empBusinessName",
    "empTradeName",
    "empAddr1",
    "empAddr2",
    "empCity",
    "empState",
    "empPostcode",
    "empCountry",
    "empProvince",
    "empPhone",
    "empPhoneext",
    "empFein",
    "empNaics",
    "empNaicsDesc",
    "empNumPayroll",
    "empYearCommenced",
    "empWorkerInterest",
    "empRelationshipWorker",
  ],
  B: [
    "empPocLastName",
    "empPocFirstName",
    "empPocMiddleName",
    "empPocJobTitle",
    "empPocAddr1",
    "empPocAddr2",
    "empPocCity",
    "empPocState",
    "empPocPostalCode",
    "empPocCountry",
    "empPocProvince",
    "empPocPhone",
    "empPocPhoneExt",
    "empPocEmail",
  ],
  C: [
    "attyAgRepType",
    "attyAgLastName",
    "attyAgFirstName",
    "attyAgMiddleName",
    "attyAgAddress1",
    "attyAgAddress2",
    "attyAgCity",
    "attyAgState",
    "attyAgPostalCode",
    "attyAgCountry",
    "attyAgProvince",
    "attyAgPhone",
    "attyAgPhoneExt",
    "attyAgEmail",
    "attyAgLawFirmName",
    "attyAgFEIN",
    "attyAgStateBarNumber",
    "attyAgGoodStandingState",
    "attyAgGoodStandingAttorney",
  ],
  // D: ["fwInfoAttyorAgent"],
  E: [
    "jobOppPWDNumber",
    "jobOppPWDAttached",
    "pwdWageRate",
    "pwdUnitOfPay",
    "jobOppWageFrom",
    "jobOppWageTo",
    "jobOppWagePer",
    "jobOppWageConditions",
  ],
  "F.a": [
    "faWorksiteLinked",
    "fwInfoAppxA_attached",
    "isAppdendixBAttached",
    "primaryWorksiteType",
    "primaryWorksiteAddr1",
    "primaryWorksiteAddr2",
    "primaryWorksiteCity",
    "primaryWorksiteCounty",
    "primaryWorksiteState",
    "primaryWorksitePostalCode",
    "primaryWorksiteBlsAreaCode",
    "primaryWorksiteBlsArea",
  ],
  "F.b": ["isMultipleLocations", "isAppdendixBAttached"],
  "F.c": ["geograpicalArea"],
  G: [
    "isFullTimeEmp",
    "isLiveInHousehold",
    "isPaidExperience",
    "isFwexecutedCont",
    "isEmpProvidedCont",
    "acceptDiplomaPwd",
    "isFwCurrentlyWrk",
    "isFwQualify",
    "empWillAccept",
    "empRelyExp",
    "fwGainExp",
    "empPayEducation",
    "jobEmpPremises",
    "jobComboOccup",
    "jobForeignLanguage",
    "jobReqExceed",
    "empUseCredential",
    "emprecpayment",
    "emPlayoff",
  ],
  "H.c": [
    "swaJobOrderStartDate",
    "swaJobOrderEndDate",
    "sundayPaperExists",
    "newspaperNameForAd",
    "newspaperAdPlacedDate",
    "advertisementMethod",
    "journalNameForAd",
    "journalAdPlacedDate",
  ],
  "H.d": [
    "jobFairIncluded",
    "jobFairFrom",
    "jobFairTo",
    "employerWebsiteIncluded",
    "employerWebsiteFrom",
    "employerWebsiteTo",
    "jobSearchWebsiteIncluded",
    "jobSearchWebsiteFrom",
    "jobSearchWebsiteTo",
    "onCampusRecruitingIncluded",
    "onCampusRecruitingFrom",
    "onCampusRecruitingTo",
    "tradeProfessionalIncluded",
    "tradeProfessionalFrom",
    "tradeProfessionalTo",
    "privateEmploymentIncluded",
    "privateEmploymentFrom",
    "privateEmploymentTo",
    "employeeReferralIncluded",
    "employeeReferralFrom",
    "employeeReferralTo",
    "campusPlacementIncluded",
    "campusPlacementFrom",
    "campusPlacementTo",
    "localEthnicNewspaperIncluded",
    "localEthnicNewspaperFrom",
    "localEthnicNewspaperTo",
    "radioTvAdIncluded",
    "radioTvAdFrom",
    "radioTvAdTo",
  ],
  "H.e": [
    "bargainingRep",
    "noBargainingRepPhysical",
    "noBargainingRepElectronic",
    "noBargainingRepInHouse",
    "noBargainingRepPrivate",
    "noBargainingRepNoNotice",
  ],
  // I: ["sectionIAgreement"],
  J: [
    "prepLastName",
    "prepfirstName",
    "prepMiddleName",
    "prepLawFirmFEIN",
    "prepFirmBusinessName",
    "prepEmail",
  ],
  // "APX A.A": [
  //   "appAContLastName",
  //   "appAContFirstName",
  //   "appAContMiddleName",
  //   "appAContAddress1",
  //   "appAContAddress2",
  //   "appAContCountryId",
  //   "appAContCity",
  //   "appAContStateId",
  //   "appAContPostalCode",
  //   "appAContProvince",
  //   "appAContDOB",
  //   "appAContAdmClassId",
  //   "appAContAlienReg",
  //   "appAContBirthCountryId",
  //   "appAContCitizenCountryId",
  //   "appAContBirthCountry",
  //   "appAContCitizenCountry",
  // ],
  // "APX A.B": [
  //   "fwEducationAppB",
  //   "appAEduTypeId",
  //   "appAEduOther",
  //   "appAEduMajors",
  //   "appAEduInstName",
  //   "appAEduCountryId",
  //   "appAEduMonthYearAttained",
  // ],
  // "APX A.C": [
  //   "fwTrainingAppC",
  //   "appATrainingInstName",
  //   "appATrainingName",
  //   "appATrainingCert",
  //   "appATrainingStartDate",
  //   "appATrainingEndDate",
  //   "appATrainingYearAwd",
  // ],
  // "APX A.D": [
  //   "fwSkillsAppD",
  //   "appASkillsInstName",
  //   "appASkillsCountryId",
  //   "appASkillsStateId",
  //   "fwTerritory",
  //   "appASkillsSpecial",
  // ],
  // "APX A.E": [
  //   "fwExpAppE",
  //   "appAExpEmpName",
  //   "appAExpAddress1",
  //   "appAExpAddress2",
  //   "appAExpCity",
  //   "appAExpPostalCode",
  //   "appAExpCountryId",
  //   "appAExpStateTerritory",
  //   "appAExpProvince",
  //   "appAExpJobTitle",
  //   "appAExpStartDate",
  //   "appAExpEndDate",
  //   "appAExpFWPresent",
  //   "appAExpWorkHour",
  //   "appAExpJobDuties",
  // ],
  "APX B": ["appx_b"],
  "APX C": ["appCSupp", "sectionAndItemNum", "sectionName", "suppInfo"],
  "APX D": [
    "appDForeignWorkerDate",
    "appDPublication1",
    "appDPublicationDate1",
    "appDPublication2",
    "appDPublicationDate2",
    "appDPublication3",
    "appDPublicationDate3",
    "appDRecruitmentInfo",
  ],
};
